import { styled } from "@mui/material/styles";
import { ColorTextMedium, ColorGray300, SizeBorderWidthThin, ColorGray600, RadiusMd, FontSize300 } from "@nxt-costco-com/forge-design-tokens";
const buttonStyles = {
  fontSize: FontSize300,
  lineHeight: "initial",
  width: "100%",
  zIndex: 2,
  minHeight: "40px",
  height: "auto"
};
const StyledOutOfStockIndicator = styled("div")({
  ...buttonStyles,
  borderRadius: RadiusMd,
  border: `${SizeBorderWidthThin} solid ${ColorGray600}`,
  background: ColorGray300,
  color: ColorTextMedium,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
});
export {
  StyledOutOfStockIndicator,
  buttonStyles
};
